module.exports = __webpack_public_path__ + "static/media/shadowHands.3d23929e.webp";